import React from 'react';
import GravityLogo from './GravityLogo';

const GPALETTE = ['#2ecc71', '#3498db', '#9b59b6', '#f39c12', '#e74c3c', '#1abc9c'];

export default function Spinner({ label }) {
  return (
    <div className="app-loader" style={{ display: 'flex' }}>
      <div className="app-loader-card">
        <div className="app-loader-logo"><GravityLogo size={68} /></div>
        <div className="app-loader-text">
          <span className="app-loader-text-sweep">{label || 'Loading Data....'}</span>
          <span className="app-loader-dots">
            {GPALETTE.map((c, i) => (
              <span key={i} style={{ color: c }}>.</span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
}
